var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-input-playground"},[_c('text-input',{attrs:{"autofocus":false,"labelText":'הכנס רק מספרים',"value":_vm.numValue,"onInput":_vm.setNumValue,"error":_vm.error,"topLeftLabel":_vm.errorLabel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }